const LOGIN_EVENT = 'user-login'

export const emitLoginEvent = () => {
  document.dispatchEvent(new CustomEvent(LOGIN_EVENT))
}
